import { createContext } from 'react';
const invariantViolation = () => {
    throw new Error('Attempted to call useHeaderHeight outside of header context. Make sure your app is rendered inside HeaderHeightProvider.');
};
export const HeaderHeightContext = createContext([0, invariantViolation]);
//# sourceMappingURL=HeaderHeightContext.js.map